import React from 'react'
import * as THREE from "three"
import { useTexture } from '@react-three/drei'
import { useSelector } from 'react-redux'

// Genera la minigonna della pedana
export default function Minigonna({posizione, altezza, lunghezza, larghezza, spessore, rotation, useLunghezza}) {
  const minigonna = useSelector(state => state.uiPedanaMenu.minigonna);

  const ironTexturesProps = useTexture({
          map: `${process.env.PUBLIC_URL}/textures/minigonna/Metal_006_basecolor.jpg`,  
          normalMap: `${process.env.PUBLIC_URL}/textures/minigonna/Metal_006_normal.jpg`,
          roughnessMap: `${process.env.PUBLIC_URL}/textures/minigonna/Metal_006_roughness.jpg`,
          aoMap: `${process.env.PUBLIC_URL}/textures/minigonna/Metal_006_ambientOcclusion.jpg`,
  })

  ironTexturesProps.map.repeat.set(5, 5);
  ironTexturesProps.normalMap.repeat.set(5, 5);
  ironTexturesProps.roughnessMap.repeat.set(5, 5);
  ironTexturesProps.aoMap.repeat.set(5, 5);

  ironTexturesProps.map.wrapS = ironTexturesProps.map.wrapT = THREE.RepeatWrapping;
  ironTexturesProps.normalMap.wrapS = ironTexturesProps.normalMap.wrapT = THREE.RepeatWrapping;
  ironTexturesProps.roughnessMap.wrapS = ironTexturesProps.roughnessMap.wrapT = THREE.RepeatWrapping;
  ironTexturesProps.aoMap.wrapS = ironTexturesProps.aoMap.wrapT = THREE.RepeatWrapping;

  return (  
    <mesh position={posizione} rotation={[0,rotation,0]}>
        {minigonna && (useLunghezza ? <boxGeometry args={[lunghezza, altezza, spessore]}/> : <boxGeometry args={[larghezza, altezza, spessore]}/>)}
        <meshStandardMaterial {...ironTexturesProps} color={0xB87333}/> 
    </mesh>
  )
}
